import React, { useEffect } from "react";
import { Modal, Form, Input, message } from "antd";
import api from "../api";

const ProductoModal = ({ open, producto, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const isEdit = !!producto;

  useEffect(() => {
    if (open) {
      if (isEdit && producto) {
        form.setFieldsValue({
          nombre: producto.nombre,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, producto, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (isEdit) {
        await api.put(`/productos/${producto.idproductos}`, values);
        message.success("Producto actualizado exitosamente");
      } else {
        await api.post("/productos", values);
        message.success("Producto agregado exitosamente");
      }
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Error al guardar producto");
      }
    }
  };

  return (
    <Modal
      title={isEdit ? "Editar Producto" : "Nuevo Producto"}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Guardar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: "El nombre es obligatorio." }]}
        >
          <Input placeholder="Ej. Pitahaya pulpa roja" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ProductoModal;
